import { API_DOMAIN } from "../../../constants";
import { normalizeTaskImages } from "../shared/taskDetailModel";
import { buildQueryPartWrite, hasPartSelection } from "../shared/queryPartPayload";

export const identifyDraftParts = parts => parts.map(part => part.id != null || part.client_key ? part : { ...part, client_key: `new-${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`}` });

export const BLANK_FORM = { vehicle_id: null, urgency: 2, assigned_to: null, remarks: "", parts: [], images: [] };

export function hydrateDraftForm(t, rawParts, actorId) {
  return {
    vehicle_id: t.vehicle_id ?? t.vehicle?.id ?? null,
    urgency: t.urgency ?? 2,
    assigned_to: t.assigned_user?.id ?? t.assigned_to ?? actorId,
    remarks: t.remarks ?? "",
    parts: rawParts.map(p => ({
      id: p.id,
      uzdpart360_part_id: p.uzdpart360_part_id ?? p.canonical_part?.id ?? null,
      part_name: p.part_name || "",
      quantity: p.quantity || 1,
      side: p.side ?? null,
      condition_preference: p.condition_preference ?? null,
      part_number: p.part_number ?? "",
      _side_manually_edited: Boolean(p.side),
    })),
    // Keep only usable stored image paths. Error objects from older
    // uploads must not satisfy the supplier-outreach photo gate.
    images: normalizeTaskImages(t.images).map((url, i) => ({
      id: `existing-${i}`,
      source: "existing",
      url,
      previewUrl: url.startsWith("http") ? url : `${API_DOMAIN}${url}`,
    })),
  };
}

export function draftWritePayload(form, queryPk, uploadedUrls) {
  if (form.parts.some(part => part.id != null && !hasPartSelection(part))) throw new Error('Choose a part name for each saved row, or remove the row before saving.');
  const validParts = form.parts.filter(hasPartSelection).map(part => ({ ...buildQueryPartWrite(part), ...(part.id != null ? { id: part.id } : { client_key: part.client_key }) }));

  return {
    task_id: queryPk,
    ...(form.vehicle_id != null && { vehicle_id: form.vehicle_id }),
    urgency: form.urgency,
    assigned_to: form.assigned_to,
    ...(form.remarks?.trim() && { remarks: form.remarks.trim() }),
    parts: validParts,
    images: uploadedUrls,
  };

}

export function draftVehicleOptions(vehicles) {
  return vehicles.map(v => {
    const brand = v.brand_name || v.brand_label || v.brand || "";
    const model = v.model_name || v.model_label || v.model || "";
    const year = v.year ? `(${v.year})` : "";
    const spec = v.country_spec ? `(${v.country_spec})` : "";
    return { value: v.id, label: [brand, model, year, spec].filter(Boolean).join(" ") };
  });
}

export function draftSendEligibility(form) {
  const hasVehicle = form.vehicle_id != null;
  const hasParts = form.parts.some(hasPartSelection);
  const hasImages = form.images.length > 0;
  const canSend = hasVehicle && hasParts && hasImages;
  const missing = [!hasVehicle && "vehicle", !hasParts && "parts", !hasImages && "images"].filter(Boolean);

  return { canSend, missing };
}
